import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  query GetProductV2ByToken($filter: FilterFindOneproductV2Input!, $token: String!) {
    getProductV2ByToken(filter: $filter, token: $token) {
      name
      description
      provider
      companyId
      defaultPrice
      currency
      unitLabel
      _id
      updatedAt
      createdAt
      prices {
        _id
      }
    }
  }
`;
